import React, { createContext, useContext, useState } from 'react';
import GlobalSpinner from './GlobleSpinner';

// Create a context for the Spinner
const SpinnerContext = createContext();

// Spinner Provider Component
export const SpinnerProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    const showSpinner = () => setIsLoading(true);
    const hideSpinner = () => setIsLoading(false);

    return (
        <SpinnerContext.Provider value={{ isLoading, showSpinner, hideSpinner }}>
            {children}
            {isLoading && <GlobalSpinner />}
        </SpinnerContext.Provider>
    );
};

// Custom hook to use SpinnerContext
export const useSpinner = () => {
    return useContext(SpinnerContext);
};
